import { Drawer, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import type { InstallPlatform } from "./install";

/** Passo a passo do iOS (não há botão de instalar) ou orientação para sair do navegador de outro app. */
export function InstallInstructions({
  open,
  onOpenChange,
  platform,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  platform: InstallPlatform;
}) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent aria-describedby={undefined}>
        <div className="flex flex-col gap-4 overflow-y-auto px-4 pt-1 pb-6 text-[15px]">
          <DrawerTitle>Instalar o Nora</DrawerTitle>
          {platform === "ios" ? (
            <>
              <p className="m-0 text-muted">No iPhone e no iPad, a instalação é pelo menu Compartilhar:</p>
              <ol className="m-0 flex list-decimal flex-col gap-2 pl-5">
                <li>
                  Toque em <strong>Compartilhar</strong> (o quadrado com a seta para cima).
                </li>
                <li>
                  Escolha <strong>Adicionar à Tela de Início</strong>.
                </li>
                <li>
                  Toque em <strong>Adicionar</strong>. O Nora aparece com os outros apps.
                </li>
              </ol>
            </>
          ) : (
            <p className="m-0">
              Este navegador fica dentro de outro app e não instala o Nora. Abra {window.location.host} no
              navegador do celular (Safari ou Chrome) e toque em <strong>Instalar app</strong>, no menu Mais.
            </p>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
